module.exports = __webpack_public_path__ + "static/media/unchecked-toggle.c209442f.svg";